import React, {Component} from 'react';
import Field from '../Field';
import TextArea from '../Field/textarea';
import validator from 'validator';
import PropTypes from 'prop-types';

class ContactForm extends Component {
  constructor (props) {
    super(props);
    this.state = {
      fields: {
        name: '',
        email: '',
        message: '',
        subject: ''
      },
      fieldErrors: {}
    };
    // required so 'this' is defined in the methods
    this.onInputChange = this.onInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  onInputChange (input) {
    const fields = this.state.fields;
    const fieldErrors = this.state.fieldErrors;
    fields[input.name] = input.value;
    fieldErrors[input.name] = input.error;
    fields.subject = 'Sales site contact form message from ' + fields.name;
    this.setState({ fields, fieldErrors });
  }

  validate () {
    const customer = this.state.fields;
    const fieldErrors = this.state.fieldErrors;
    const errMessages = Object.keys(fieldErrors).filter((k) => fieldErrors[k]);
    if (!customer.name) return false;
    if (!customer.email) return false;
    if (!customer.message) return false;
    if (errMessages.length) return false;
    return true;
  }

  handleSubmit (event) {
    event.preventDefault();
    if (this.validate()) {
      this.props.onSubmitClick(this.state.fields);
    }
  }

  render () {
    return (
      <div className='l-container'>
        <h1 className='u-text-center'>Use the form below to get in touch with us</h1>
        <div className='l-container l-container--x-narrow'>
          <form noValidate onSubmit={this.handleSubmit}
            onChange={this.handleChange}
            className='island island--dark'>
            <ul className='form-fields'>
              <li>
                <label>Name</label>
                <Field
                  name='name'
                  type='text'
                  value={this.state.fields.name}
                  onChange={this.onInputChange}
                  validate={(val) => (val ? false : 'Name Required')}
                />
              </li>
              <li>
                <label>Email</label>
                <Field
                  name='email'
                  type='email'
                  value={this.state.fields.email}
                  onChange={this.onInputChange}
                  validate={(val) => (validator.isEmail(val) ? false : 'Invalid Email')}
                />
              </li>
              <li>
                <label>Message</label>
                <TextArea
                  name='message'
                  value={this.state.fields.message}
                  onChange={this.onInputChange}
                  validate={(val) => (val ? false : 'Message Required')}
                />
              </li>
              <li className='form__actions'>
                <button className='button button--shadow disabled' type='submit' disabled={!this.validate()}>Send enquiry</button>
                <span style={{marginLeft: 20}}>{this.state.successMessage}</span>
              </li>
            </ul>
          </form>
          <aside className='contact-details'>
            <div className='contact-details__row'>
              <dl>
                <dt className='epsilon'>Email</dt>
                <dd><a href='mailto:info@bslcourses.co.uk'>info@bslcourses.co.uk</a></dd>
              </dl>
              <dl>
                <dt className='epsilon'>Phone</dt>
                <dd><a href='tel:00441243210219'>01243 210219</a></dd>
              </dl>
              <dl>
                <dt className='epsilon'>SMS</dt>
                <dd><a href='tel:0447581365492'>07581 365492</a></dd>
              </dl>
            </div>
            <div className='contact-details__row'>
              <a href='http://www.facebook.com/pages/BSLcourses/152665524789200?sk=wall'>
                <svg className='icon icon-facebook-circle' aria-hidden='true'>
                  <use xlinkHref='#facebook-circle' />
                </svg>Facebook</a>
              <a href='https://twitter.com/BSLcourses'>
                <svg className='icon icon-twitter-circle' aria-hidden='true'>
                  <use xlinkHref='#twitter-circle' />
                </svg>Twitter</a>
            </div>
          </aside>
        </div>
      </div>
    );
  }
}

ContactForm.propTypes = {
  onSubmitClick: PropTypes.func
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js